export const vpnService = {
  openvpn_active: "openvpnActive",
  for_windows: "window",
  for_non_windows: "non_window",
  for_smart_phone: "smart_phone",
  link_windows: "vpn_instruction_windows",
  link_macosx: "vpn_instruction_mac",
  link_iphone: "vpn_instruction_iphone",
  link_andriod: "vpn_instruction_android",
  openvpn_tun_service_port: "tun_vpn_port",
  openvpn_service_port: "vpn_port",
};

export default vpnService;
